module.exports = __webpack_public_path__ + "static/foundersfoundation-bd55dadad9406a3e29ed4bc3085791e5.png";